// extracted by mini-css-extract-plugin
module.exports = {"main":"error_main__29kPI","errorImage":"error_errorImage__cSpc4","button":"error_button__yDiQt"};